import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

// material-ui
import { Box, Button, Grid, Tab, Tabs, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ScoreboardRoundedIcon from '@mui/icons-material/ScoreboardRounded';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import BookIcon from '@mui/icons-material/Book';

// project imports
import BoardBookings from 'views/Bookings/BoardBookings';
import BoardLog from './BoardLog';
import BoardStatistics from './BoardDashBoard';
import BoardUsageLog from './BoardUsageLog';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

// tabs panel
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
};

// tabs option
const tabsOption = [
    {
        label: 'DashBoard',
        icon: <DashboardIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
        label: 'Bookings',
        icon: <ScoreboardRoundedIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
        label: 'Active Log',
        icon: <TextSnippetIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
        label: 'Usage Log',
        icon: <BookIcon sx={{ fontSize: '1.3rem' }} />
    }

];

const ViewBoard = () => {

    const theme = useTheme();

    const [value, setValue] = useState(0);
    const [selectedBoard, setSelectedBoard] = useState(null);
    const { boardUuid } = useParams();
    const navigate = useNavigate();

    const handleOnClick = () => {
        navigate(`/board`);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getBoardHandler = (response) => {
        setSelectedBoard(response.data);
    };

    const getBoardByUuidApi = useApi(VenueService.getBoardByUuid, getBoardHandler);

    useEffect(() => {
        getBoardByUuidApi.execute(boardUuid)
    }, [boardUuid]
    );

    return (<>
        <MainCard>
            <Grid container xs={12} sx={{ gap: 5 }}>
                <Grid xs={3} sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Typography variant='subtitle2'> Venue Name&nbsp;:&nbsp;</Typography>
                    <Typography variant='h4'>
                        {selectedBoard ? selectedBoard.venue_name : ""}
                    </Typography>
                </Grid>
                <Grid xs={3} sx={{ display: 'flex', flexDirection: 'row', gap: '2' }}>
                    <Typography variant='subtitle2'>Court Name&nbsp;:&nbsp;</Typography>
                    <Typography variant='h4'>
                        {selectedBoard ? selectedBoard.turf_name : ""}
                    </Typography>
                </Grid>
                <Grid xs={3} sx={{ display: 'flex', flexDirection: 'row', gap: '2' }}>
                    <Typography variant='subtitle2'>Board Name&nbsp;:&nbsp;</Typography>
                    <Typography variant='h4'>
                        {selectedBoard ? selectedBoard.name : ""}
                    </Typography>
                </Grid>
                {/* <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', marginLeft: 10 }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        size='small'
                        onClick={() => handleOnClick()}
                    >
                        Back
                    </Button>
                </Grid> */}
            </Grid>
            <Grid container spacing={gridSpacing} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        variant="scrollable"
                        sx={{
                            mb: 3,
                            '& a': {
                                minHeight: 'auto',
                                minWidth: 10,
                                py: 1.5,
                                px: 1,
                                mr: 2.25,
                                color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.550',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            '& a.Mui-selected': {
                                color: theme.palette.primary.main
                            },
                            '& .MuiTabs-indicator': {
                                bottom: 2
                            },
                            '& a > svg': {
                                marginBottom: '0px !important',
                                mr: 1.25
                            }
                        }}
                    >
                        {tabsOption.map((tab, index) => (
                            <Tab key={index} component={Link} to="#" icon={tab.icon} label={tab.label} {...a11yProps(index)} />
                        ))}
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        <BoardStatistics boardUuid={boardUuid} />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <BoardBookings boardUuid={boardUuid} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <BoardLog boardUuid={boardUuid} viewType="board" />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <BoardUsageLog boardUuid={boardUuid} viewType="board" />
                    </TabPanel>
                </Grid>
            </Grid>
        </MainCard>
    </>
    );
};

export default ViewBoard;
